<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'TU'" [name]="'Lista'"></app-breadcrumb>
<div class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">
    <mat-form-field class="list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Nazwa" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Pełna nazwa</mat-label>
      <input matInput placeholder="Pełna nazwa" name="contains$fullName" [(ngModel)]="initialFilters.contains$fullName">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'insurance_type'"
      [label]="'Typ'" class="list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'company'"
      [label]="'Firma'" class="list-filter"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <mat-form-field appearance="standard" class="list-filter">
      <mat-label>Zablokowane rejestracje</mat-label>
      <mat-select [(ngModel)]="initialFilters.blockRegistrations" name="blockRegistrations">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="list-filter">
      <mat-label>Aktywne</mat-label>
      <mat-select [(ngModel)]="initialFilters.inactive" name="inactive">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="0">Tak</mat-option>
        <mat-option [value]="1">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="list-buttons">
   <a class="default-link" [routerLink]="['/tu/dodaj']">
     <button  [disabled]="!(userPermissions | async).insurance_company.create"
              mat-raised-button class="report-button"><mat-icon>add</mat-icon> Dodaj</button></a>

    <button *ngIf="(userPermissions | async).insurance_company.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).insurance_company.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="insuranceCompanies">

    <!-- Position Column -->
    <ng-container matColumnDef="logo">
      <th mat-header-cell *matHeaderCellDef> Logo </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        <img *ngIf="element.imageLocation" src="/rest/crm/insuranceCompany/{{element.id}}/image" alt="Zdjęcie" height="30"/>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/tu/szczegoly', element.id]">
          {{element.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef> Pełna nazwa</th>
      <td mat-cell *matCellDef="let element">
        {{element.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Typ</th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="companies">
      <th mat-header-cell *matHeaderCellDef> Firmy</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let company of element.companies">
          {{company.name}} <br>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="blocked">
      <th mat-header-cell *matHeaderCellDef> Zablokowane rejestracje</th>
      <td mat-cell *matCellDef="let element">
        {{element.blockRegistrations ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="inactive">
      <th mat-header-cell *matHeaderCellDef> Aktywne </th>
      <td mat-cell *matCellDef="let element">
        {{!element.inactive ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
